import * as ActionPartnerTypes from 'actions/partner';

const defaultState = { groupCohorts: [], groupCohortsByOrganizationType: [] };

export default function accounts(state = defaultState, action) {
  switch (action.type) {
    case ActionPartnerTypes.REPORT_GROUP_COHORT_RECEIVE:
      return { ...state, groupCohorts: action.payload.data };
    case ActionPartnerTypes.REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_RECEIVE:
      return { ...state, groupCohortsByOrganizationType: action.payload.data };
    default:
      return state;
  }
}
